import React, { useEffect } from 'react';
import { useAuth } from 'hooks/useAuth';
import FullscreenLoader from '@/components/ui/fullscreen-loader';

const Logout: React.FC = () => {
  const { logout } = useAuth();

  useEffect(() => {
    // Execută logout-ul automat când componenta se montează
    logout();
  }, [logout]);

  // Afișează un loader în timpul procesului de logout
  return <FullscreenLoader />;
};

export default Logout;